import React from "react";

import SocialMediaIcons from "../../UI/social-media-icons";

const Hero = () => {
  return (
    <>
      <div className="text-center py-24 lg:py-32">
        <h1 className="text-4xl lg:text-6xl lg:tracking-[-7px] font-popinsBold text-themeColor">
          Brains. Vision. Execution.
        </h1>
        <p className="text-textColor font-popinsMedium text-base lg:w-[45%] mx-auto pt-3">
          A dedicated team of tech enthusiasts, property experts, and
          innovators. Together, we’re building smarter solutions for modern
          property management.
        </p>
      </div>
      <div className="bg-[#F0F7FC] flex flex-col items-center py-12">
        <h3 className="font-popinsBold text-themeColor text-3xl">
          Alex Carter
        </h3>
        <p className="text-textColor font-popinsMedium text-lg pt-2">
          Our Founder
        </p>
        <img
          src="/assets/our-team/team.png"
          alt=""
          className="size-[200px] rounded-full object-cover mt-10 mb-2"
        />
        <SocialMediaIcons />
        <div className="w-[90%] lg:w-[65%] mx-auto mt-10">
          <p className="font-popinsMedium text-textColor text-base">
            With over a decade of experience in the fitness industry, Alex
            specializes in strength training and functional fitness. Certified
            by NASM and known for his motivational style, Alex designs workout
            programs that are both challenging and achievable. His passion lies
            in helping clients build strength and confidence through
            personalized training routines. Outside the gym, Alex is an avid
            runner and enjoys outdoor adventures.
          </p>
          <p className="font-popinsMedium text-textColor text-base pt-5">
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
            commodo ligula eget dolor. Aenean massa. Cum sociis natoque
            penatibus et magnis
          </p>
          <p className="font-popinsMedium text-textColor text-base pt-5">
            dis parturient montes, nascetur ridiculus mus. Donec quam felis,
            ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat
            massa quis enim.
          </p>
          <p className="font-popinsMedium text-textColor text-base pt-5">
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
            commodo ligula eget dolor. Aenean massa. Cum sociis natoque
            penatibus et magnis dis parturient montes, nascetur ridiculus
          </p>
        </div>
      </div>
    </>
  );
};

export default Hero;
